module.exports = __webpack_public_path__ + "img/5.196a4b7f.jpg";